import { SpinnerLoading } from "@/main/components/shared/styles";
import styled from "styled-components";

export const Container = styled.div``;

export const FileNameArea = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
`;
export const FileNameText = styled.span`
	display: inline-block;
	max-width: 230px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: pre;
`;
export const AreaButtons = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 20px);
	justify-content: end;
	align-items: center;
	gap: 0.4rem;

	${SpinnerLoading} {
		margin: 0 !important;
	}
`;
